import React, {useCallback, useEffect, useState} from "react";

import {checkUserLoggedStatus} from "../helpers/helper-functions";
import "bootstrap";
import {withFirebase} from "../components/Firebase";
import CategoryChoiceBox from "../components/Selections/CategoryChoiceBox";
// @ts-ignore
import {SolarSystemLoading} from "react-loadingg";
import { RouteComponentProps } from 'react-router-dom';

export interface ReviewCategoriesProps extends RouteComponentProps {
    firebase: any,
}

export const ReviewCategories = (props: ReviewCategoriesProps) => {
    useEffect(() => {
        document.title = "Review Categories";
        checkUserLoggedStatus();
    }, []);

    const getCategories = useCallback(() => {
        props.firebase
            .getQuizCategories()
            .then((res: any) => {
                console.log("This is the response", res);
                setCategories(["Knowledge Areas", "Techniques"]);
                setCategoryData({
                    "Knowledge Areas": res.knowledgeAreas,
                    Techniques: res.techniques,
                });
                setIsPageLoaded(true);
                return res;
            })
    }, [props.firebase])

    useEffect(() => {
        getCategories();
    }, [getCategories]);

    const [categories, setCategories] = useState<string[]>([]);
    const [subCategories, setSubCategories] = useState<string[]>([]);
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [categoryData, setCategoryData] = useState<Record<string, any>>({});
    const [questions, setQuestions] = useState<Record<string, any>>({});

    function fetchQuestionsFromDb(category: string, answeredQuestionsIds: string[]) {
        props.firebase
            .doGetQuizQuestionsByCategory(category)
            .then((res: any) => {
                const newArray = res.filter((item: any, index: number) => res.indexOf(item) === index); // remove duplicates
                let notAnsweredQuestions: any;
                if (answeredQuestionsIds) {
                    notAnsweredQuestions = newArray.filter((v: any) => {
                        const result = answeredQuestionsIds.find(
                            (answeredId) => answeredId === v.id
                        );
                        return result === undefined;
                    });
                } else {
                    notAnsweredQuestions = newArray;
                }
                setQuestions(questions => {
                    return {
                        ...questions,
                        [category]: notAnsweredQuestions, //  notAnsweredQuestions
                    }
                });
                setIsPageLoaded(true);
            })
            .catch((error: any) => {
                console.log("Error" + error);
            });
    }

    function getAnsweredQuestions() {
        return props.firebase.getAnsweredQuestionsIds();
    }

    function goBack() {
        if (subCategories.length !== 0) {
            setSubCategories([]);
        } else {
            window.location.href = "/student/home";
        }
    }

    async function getSubCategories(category: string) {
        let answeredQuestionsIds = await getAnsweredQuestions();
        const newArray = categoryData[category];
        newArray.forEach((v: any) => {
            fetchQuestionsFromDb(v, answeredQuestionsIds);
        });
        setSubCategories([...newArray] as any);
        setIsPageLoaded(true);
    }

    async function fetchSubCategories(category: string) {
        setIsPageLoaded(false);
        await getSubCategories(category);
    }

    const NextArrow = (
        <div className="row" aria-label={"next button"}>
            <p style={{color: "#192438", fontSize: "20px", marginRight: 20}}>
                Next
            </p>
            <img
                alt={"next"}
                src={require("../assets/images/right-arrow.png")}
                style={{height: "20px", marginTop: 5}}
            />
        </div>
    );

    if (!isPageLoaded) {
        return (
            <SolarSystemLoading
                style={{position: "fixed", top: "50%", left: "50%"}}
            />
        );
    }

    return (
        <div style={{height: window.innerHeight, overflowY: "scroll"}}>
            <div className="container main-content-container px-4">
                <div className="row m-md-2" style={{justifyContent: "flex-end"}}>
                    <div className="col m-md-2" style={{top: "20px"}}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            style={{
                                marginTop: "3px",
                                marginLeft: "20px",
                                cursor: "pointer",
                            }}
                            fill="none"
                            stroke="gray"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-home"
                            onClick={() => {
                                window.location.href = "/student/home";
                            }}
                        >
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                            <polyline points="9 22 9 12 15 12 15 22"></polyline>
                        </svg>
                        <p
                            style={{
                                float: "right",
                                marginRight: "10px",
                                fontSize: "20px",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                props.firebase
                                    .doSignOut()
                                    .then(() => {
                                        sessionStorage.setItem("userLoggedIn", "false");
                                    })
                                    .then(() => {
                                        window.location.href = "/student/signin";
                                    });
                            }}
                        >
                            Log out
                        </p>
                    </div>
                </div>
                <div
                    className="row"
                    style={{justifyContent: "center"}}
                >
                    <p className="page-title" style={{fontSize: "25px"}}>
                        {subCategories.length > 0
                            ? "Choose a knowledge area..."
                            : "Choose a sub category..."}
                    </p>
                </div>
                {subCategories.length > 0
                    ? subCategories.map((v, i) => (
                        <div
                            key={i}
                            className="row"
                            style={{justifyContent: "center"}}
                        >

                            <CategoryChoiceBox
                                onClick={() => {
                                    props.history.push(`/student/quiz/${v}`);
                                }}
                                message={v}
                            />
                        </div>
                    ))
                    : categories.map((v, i) => (
                        <div
                            key={i}
                            className="row"
                            style={{justifyContent: "center"}}
                        >
                            <div
                                onClick={() => {
                                    fetchSubCategories(v);
                                }}
                            >
                                <CategoryChoiceBox
                                    message={v}
                                />
                            </div>
                        </div>
                    ))}
                <div
                    className="row"
                    style={{paddingTop: "2%", justifyContent: "center"}}
                >
                    <div className="col col-lg-5">
                        <div className="row">
                            <div className="col">
                                <div onClick={goBack} className="row">
                                    <img
                                        alt={"left arrow'"}
                                        src={require("../assets/images/left-arrow.png")}
                                        style={{height: "20px", marginTop: 5}}
                                    />
                                    <p
                                        style={{
                                            color: "#192438",
                                            fontSize: "20px",
                                            marginLeft: 20,
                                            cursor: "pointer",
                                        }}
                                    >
                                        Back
                                    </p>
                                </div>
                            </div>
                            <div className="col">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withFirebase(ReviewCategories);
